module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/cocktail@2x_3aaaaa.jpg";